export default __webpack_public_path__ + "static/16-ae9ed25970b30bada050826a01e7c5b4.jpg";